<template>
  <main class="login loading-splash">
    <LoadingIcon />
    <span>Loading User Data…..</span>
  </main>
</template>

<script setup lang="ts">
import LoadingIcon from "@/assets/icons/loading.svg";
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
